import type { JSX } from 'react';

import { Container } from '@change-corgi/design-system/layout';

import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { PageFooter } from '../components/PageFooter';
import { PageHeading } from '../components/PageHeading';
import { PageMeta } from '../components/PageMeta';

import { useTrackPageView } from './hooks/useTrackPageView';

export function Layout(): JSX.Element {
	useTrackPageView();

	return (
		<>
			<PageMeta />
			<PageBanner />
			<Container variant="small" mt={16} pb={16}>
				<PageHeading px={[16, 8]} />
				<PageBody mt={32} mb={24} px={[16, 8]} />
			</Container>
			<PageFooter pb={32} />
		</>
	);
}
